import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultContactInfo,
  defaultCosts,
  defaultOfficeBasicInfo,
  defaultOfficeRentOtherFacilities,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const tenantOfficeRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: defaultOfficeBasicInfo,
  costs: defaultCosts,
  otherFacilities: defaultOfficeRentOtherFacilities,
  description: {
    adTitle: validationRules.adTitle,
    adDescription: validationRules.adDescription,
    adLocation: validationRules.adLocation,
  },
  contactInfo: defaultContactInfo,
  connections: defaultConnections,
}
